import { Reveal } from "../components/Reveal";
import { TESTIMONIALS } from "../data/testimonials";

// Selected client testimonials — hairline grid in the DCC editorial language.
// Three columns on desktop, two on tablet, one on mobile; every card reads
// from the single shared source in data/testimonials.js so a person's photo,
// name, designation, organisation or quote can be edited in exactly one place.
export function Testimonials() {
  return (
    <section className="bg-paper py-16 md:py-24" aria-label="Client testimonials">
      <div className="container-x">
        <Reveal>
          <p className="eyebrow">Genuine feedback from engineering leaders in hospitality and operating facilities</p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-px border border-zinc-200 bg-zinc-200 md:grid-cols-2 lg:grid-cols-3" data-testid="testimonials-grid">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.order} delay={Math.min(i * 0.05, 0.3)} className="h-full">
              <figure className="flex h-full flex-col bg-paper p-8 md:p-10" data-testid={`testimonial-card-${t.order}`}>
                <figcaption className="sr-only">
                  {t.name}, {t.designation}, {t.organisation}
                </figcaption>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-dcc-strong" data-testid={`testimonial-theme-${t.order}`}>
                  {t.theme}
                </p>
                <blockquote className="mt-8 text-base leading-relaxed text-zinc-700" data-testid={`testimonial-quote-${t.order}`}>
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <div className="mt-auto pt-10">
                  <div className="flex items-center gap-4 border-t border-zinc-200 pt-8">
                    <img
                      src={t.photoSrc}
                      alt={`Portrait of ${t.name}`}
                      width="96"
                      height="96"
                      loading="lazy"
                      decoding="async"
                      className="h-14 w-14 shrink-0 rounded-full border border-zinc-200 object-cover"
                      style={{ objectPosition: t.pos || "center" }}
                      data-testid={`testimonial-photo-${t.order}`}
                    />
                    <div>
                      <p className="font-display text-base font-semibold text-charcoal" data-testid={`testimonial-name-${t.order}`}>{t.name}</p>
                      <p className="mt-1 text-sm text-zinc-600" data-testid={`testimonial-role-${t.order}`}>
                        {t.designation} · {t.organisation}
                      </p>
                    </div>
                  </div>
                </div>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
            Selected feedback shown with permission of use for reference. Complete client database is confidential.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
